import type { FC, ReactElement } from 'react';
import React from 'react';
import { Tooltip } from 'react-tooltip';

export interface InputFieldProps {
	label?: string;
	id: string;
	extra?: string;
	inputExtra?: string;
	type: string;
	placeholder: string;
	// variant: string;
	checked?: boolean;
	name: string;
	required?: boolean;
	defaultValue?: string;
	autoComplete?: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	removeMarginOnLabel?: boolean;
	disabled?: boolean;
	maxLength?: number;
	min?: number;
	max?: number;
	tooltipText?: string;
	editable?: boolean;
	dataTestIdInput?: string;
	dataTestIdLabel?: string;
	value?: string;
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const InputField: FC<InputFieldProps> = ({
	label,
	id,
	extra = '',
	inputExtra = '',
	type,
	placeholder,
	// variant,
	name,
	disabled = false,
	required = false,
	defaultValue = '',
	autoComplete = '',
	onChange,
	removeMarginOnLabel = false,
	maxLength,
	tooltipText = '',
	editable = false,
	dataTestIdInput = 'input',
	dataTestIdLabel = 'label',
	checked,
	value,
	onKeyDown,
	onBlur,
}: InputFieldProps): ReactElement => {
	const isControlled = value || checked !== undefined;

	return (
		<div className={`${extra || ''}`}>
			{label && (
				<label
					data-testid={dataTestIdLabel}
					htmlFor={id}
					className={`${removeMarginOnLabel ? 'mb-0' : 'mb-2'} flex text-sm font-medium text-[#212636] ${
						type === 'checkbox' ? 'cursor-pointer' : 'cursor-default'
					}`}>
					{label}
					{tooltipText && (
						<img
							data-tooltip-id={`tooltip-${id}`}
							className="ml-2 w-4 cursor-pointer"
							src="/images/infoIcon.svg"
							alt="Info"
						/>
					)}
				</label>
			)}
			<div>
				<input
					data-testid={dataTestIdInput}
					onChange={onChange}
					type={type}
					id={id}
					name={name}
					placeholder={placeholder}
					required={required}
					className={`flex w-full items-center justify-center rounded-xl border border-[#dbdde1]  px-3 py-2.5 text-sm text-black shadow-sm outline-none placeholder:text-gray-DEFAULT-400 focus:border-blueSecondary ${inputExtra || ''}`}
					autoComplete={autoComplete}
					readOnly={editable}
					maxLength={maxLength}
					disabled={disabled}
					{...(isControlled ? typeof checked === 'boolean' ? { checked } : { value, onChange } : { defaultValue })}
					onKeyDown={onKeyDown}
					onBlur={onBlur}
				/>
				{tooltipText && (
					<Tooltip id={`tooltip-${id}`} className="label-tooltip" place="top" content={`${tooltipText}`} />
				)}
			</div>
		</div>
	);
};

export default InputField;
